<template>
  <div>
    <!-- 删除弹框 -->
    <Dialogs
      :dialogs="dialog"
      @dialogVisible="beforeClose"
      width="50%"
    >
      <template #desc>
        <div class="subbox">项目删除后可在“ 我的-回收站 ”中查看，不可进行操作，不纳入统计。可随时取消项目删除，正常使用该项目。</div>
      </template>
    </Dialogs>
    <!-- 复制项目弹框 -->
    <Dialogs :dialogs="dialog2" @dialogVisible="beforeClose">
      <template #desc>
        <div class="copy_conyent">
          <div>
            <div class="copy_label">项目名称</div>
            <div class="copy_value">
              <el-input
                :autofocus="true"
                v-model="dialog2.proname"
                placeholder="点击添加"
              />
            </div>
          </div>
          <div>
            <div class="copy_label">项目计划时间</div>
            <div class="copy_value" style="width:70%">
              <el-date-picker
                type="date"
                v-model="dialog2.planStartDate"
                placeholder="点击添加"
                value-format="yyyy/MM/dd HH:mm:ss"
                format="yyyy/MM/dd"
                :clearable="false"
                @focus="focusStartChange"
                :picker-options="pickerOptions"
                style="width:100%"
              />
              <div style="color:#909090;margin:0 10px">-</div>
              <el-date-picker
                type="date"
                v-model="dialog2.planEndDate"
                placeholder="点击添加"
                value-format="yyyy/MM/dd HH:mm:ss"
                format="yyyy/MM/dd"
                :clearable="false"
                @focus="focusEndChange"
                :picker-options="pickerOptions1"
                style="width:100%"
              />
            </div>
          </div>
          <div>
            <div class="copy_label">项目简介</div>
            <div class="copy_value">
              <Describe :describes="dialog2.describes" />
            </div>
          </div>
          <div>
            <div class="copy_label">项目标签</div>
            <div class="copy_value">
              <div class="copy_tags">
                <div class="copy_tags_box" v-for="(tag,index) in dialog2.labelList" :key="index" v-show="dialog2.labelList&&dialog2.labelList.length>0">
                  <el-tag
                    style="margin-right: 16px"
                    :style="'color:'+tag.color+';background:'+convertHex(tag.color, 10)"
                    type="warning"
                  >{{tag.labelName}}</el-tag>
                  <i class="iconfont icon-shanchu del_icon" @click="delTagsChange(tag)" />
                </div>
                <el-popover
                  placement="bottom"
                  width="540"
                  trigger="click"
                >
                  <TagsList :tags-objects="tagsObject1" :tag-lists="tagList" />
                  <i class="iconfont icon-jiahao2fill add_icon" :style="dialog2.labelList&&dialog2.labelList.length>0?'margin: 0 24px;':'margin: 0'" slot="reference" />
                </el-popover>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Dialogs>
    <!-- 复制项目高级选项弹框 -->
    <Dialogs :dialogs="dialogCopyHeight" @dialogVisible="beforeClose">
      <template #desc>
        <div class="desc_boxs">
          <div style="height:562px">
            <div class="tt">
              <div class="task-name">项目编号</div>
              <div>
                <el-input v-model="dialogCopyHeight.proNumber" />
              </div>
            </div>
            <div>
              <div class="seleTime">计划时间</div>
              <el-radio-group v-model="dialogCopyHeight.dateType">
                <el-radio label="0">保留所有任务起止时间</el-radio>
                <el-radio label="1">清空所有新任务的起止时间</el-radio>
                <el-radio label="2">所有计划时间顺延
                  <span class="aa"> <el-input v-model="dialogCopyHeight.putOff" @blur="putOffBlur" /></span>
                  天
                </el-radio>
              </el-radio-group>
            </div>
            <div>
              <div class="seleCopy">复制选项</div>
              <div class="sele-copy">
                <el-checkbox-group v-model="dialogCopyHeight.checkList">
                  <el-checkbox label="1">任务</el-checkbox>
                  <el-checkbox label="2">文件</el-checkbox>
                  <el-checkbox label="3">标签</el-checkbox>
                  <el-checkbox label="4">关注人</el-checkbox>
                  <el-checkbox label="5">关联关系</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Dialogs>
    <!-- 归档项目弹框 -->
    <Dialogs :dialogs="dialog3" @dialogVisible="beforeClose">
      <template #desc>
        <div class="archive_content">{{dialog3.desc}}</div>
      </template>
    </Dialogs>
    <!-- 上传封面弹框 -->
    <Dialogs :dialogs="dialog4" @dialogVisible="beforeClose">
      <template #desc>
        <div class="cover_box">
          <div class="cover_left">
            <div class="cover_title">系统封面</div>
            <div class="cover_list">
              <div v-for="(item,index) in coverImgList" :key="index">
                <img class="cover_img" :src="item.url" @click="coverImg(item)">
              </div>
            </div>
          </div>
          <div class="cover_right">
            <div class="cover_title">自定义封面</div>
            <div class="cover_select">
              <div>预览</div>
              <div style="margin:0 17px">
                <div class="preview_img">
                  <img v-if="!coverImgInfo_.url" style="width:100%" src="https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/direct.png">
                  <img v-if="coverImgInfo_.url" style="width:100%" :src="coverImgInfo_.url" @error="setDefaultImage">
                </div>
                <div>
                  <!--  action="https://app117677.eapps.dingtalkcloud.com/scpcm/file/fileUpload" -->
                  <el-upload
                    ref="“upload”"
                    class="upload-demo"
                    action="https://app117677.eapps.dingtalkcloud.com/scpcm/file/fileUpload"
                    :show-file-list="false"
                    :headers="config"
                    accept=".jpg,.jpeg,.png,.JPG,.JPEG"
                    :data="{id: proid}"
                    :on-success="successFile"
                    :before-upload="beforeUpload"
                    :on-progress="progress"
                    :disabled="!fileButten"
                  >
                    <el-button type="primary" style="width: 162px;text-align:center;display: flex;justify-content: center;">
                      <i class="iconfont icon-daochu upload_icon" style="font-size: 15px;padding: 0 2px;"/>
                      自定义封面
                    </el-button>
                  </el-upload>
                </div>
                <div class="cover_text" style="margin-top:11px">建议尺寸：504 X 282</div>
                <div class="cover_text">文件大小：5M以内</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Dialogs>
  </div>
</template>

<script>
import Describe from '../../components/common/describe.vue'
import Dialogs from '../../components/common/dialog.vue'
import TagsList from '../../components/common/tagsList.vue'
import { editChange, delChange } from '../../utils/tag.js'
var cover_1 = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/cover_1.png'
var cover_2 = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/cover_2.png'
var cover_3 = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/cover_3.png'
var cover_4 = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/cover_4.png'
var cover_5 = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/cover_5.png'
var cover_6 = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/cover_6.png'
var cover_7 = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/cover_7.png'
var cover_8 = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/cover_8.png'
import {
  getProNumber,
  filingPro,
  delPro,
  copyPro,
  findLabelList
} from '../../utils/api/project'
export default {
  name: 'DrawerDetails',
  components: {
    Describe, Dialogs, TagsList
  },
  props: {
    drawer: {
      type: Object,
      default: () => ({})
    },
    proid: {
      type: String,
      default: () => ({})
    }
  },
  data() {
    return {
      fileButten: true,
      config: {
        sessiontoken: JSON.parse(sessionStorage.getItem('loginUserData')).sessionTokenId
      },
      coverImgList: [{
        name: 'cover_1',
        url: cover_1
      }, {
        name: 'cover_2',
        url: cover_2
      }, {
        name: 'cover_3',
        url: cover_3
      }, {
        name: 'cover_4',
        url: cover_4
      }, {
        name: 'cover_5',
        url: cover_5
      }, {
        name: 'cover_6',
        url: cover_6
      }, {
        name: 'cover_7',
        url: cover_7
      }, {
        name: 'cover_8',
        url: cover_8
      }],
      coverImgInfo: {},
      coverImgInfo_: {},
      dataListShow: false,
      dataList: [],
      // 时间选择范围
      pickerOptions: {},
      // 时间选择范围
      pickerOptions1: {},
      // 标签列表
      tagList: [],
      tagsObject1: {
        checkboxGroup: [],
        fun: this.checkboxGroupChange1
      },
      // 删除弹框
      dialog: {
        addDounced: false, // 显示新增
        title: '删除项目',
        width: '492px',
        slotName: 'desc',
        id: '',
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '确定', type: 'danger', fun: this.submitDelDialog }
        ]
      },
      // 复制弹框
      dialog2: {
        addDounced: false, // 显示新增
        title: '复制项目',
        width: '777px',
        slotName: 'desc',
        proname: '',
        planStartDate: '',
        planEndDate: '',
        describes: {
          describe: '',
          maxlength_show: true,
          descList: [],
          appendType: '1'
        },
        labelList: [],
        // 操作按钮
        operatorList: [
          { label: '高级选项', type: 'aa', fun: this.advancedSele },
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '确定', type: 'primary', fun: this.submitDialog2 }
        ]
      },
      // 复制弹框高级选项
      dialogCopyHeight: {
        addDounced: false, // 显示新增
        title: '复制项目',
        width: '896px',
        slotName: 'desc',
        proNumber: '',
        dateType: '0',
        putOff: 0,
        checkList: ['1', '2', '3', '4', '5'],
        // 操作按钮
        operatorList: [
          { label: '上一步', type: '', fun: this.lastStep },
          { label: '复制', type: 'primary', fun: this.copyTask }
        ]
      },
      // 归档弹框
      dialog3: {
        addDounced: false, // 显示新增
        title: '归档项目',
        width: '492px',
        slotName: 'desc',
        desc: '项目归档后可在“ 项目-已归档 ”中查看，不可进行操作，不纳入统计。可随时取消项目归档，正常使用该项目。',
        id: '',
        proTypeId: '',
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '归档', type: 'danger', fun: this.submitFilingDialog }
        ]
      },
      // 上传封面
      dialog4: {
        addDounced: false,
        title: '上传封面',
        width: '896px',
        slotName: 'desc',
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', fun: this.cancelDialog },
          { label: '确定', type: 'primary', fun: this.submitCoverDialog }
        ]
      },
      project_id: ''
    }
  },
  mounted() {
    this.project_id = this.$route.query.id
  },
  methods: {
    // 打开项目复制
    copyDialog(row) {
      this.dialog2.proname = row.proname
      this.dialog2.planStartDate = row.planStartDate
      this.dialog2.planEndDate = row.planEndDate
      this.dialog2.describes.describe = row.proRemark
      this.dialog2.describes.descList = row.fileList
      this.dialog2.labelList = row.labelList
      this.tagsObject1.checkboxGroup = []
      this.dialogCopyHeight.dateType = '0'
      this.dialogCopyHeight.putOff = 0
      this.dialogCopyHeight.checkList = ['1', '2', '3', '4', '5']
      this.dialog2.addDounced = true
      this.getTabsList()
    },
    // 项目标签列表
    getTabsList() {
      this.tagsObject1.checkboxGroup = []
      findLabelList().then((data) => {
        if (data.code === 10000) {
          this.tagList = data.result
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 编辑项目复制标签
    checkboxGroupChange1() {
      this.dialog2.labelList = editChange(this.tagList, this.tagsObject1.checkboxGroup)
      // console.log(this.dialog2.labelList, '-=0-09-09-09-09-0')
    },
    // 删除项目标签
    delTagsChange(tag) {
      this.tagsObject1.checkboxGroup.splice(delChange(tag, this.tagsObject1.checkboxGroup), 1)
      this.checkboxGroupChange1()
    },
    // 标签透明度
    convertHex(hex, opacity) {
      hex = hex?.replace('#', '')
      var r = parseInt(hex?.substring(0, 2), 16)
      var g = parseInt(hex?.substring(2, 4), 16)
      var b = parseInt(hex?.substring(4, 6), 16)
      var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
      return result
    },
    // 失败图片
    setDefaultImage(e) {
      e.target.src = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/direct.png'
    },
    // 图片上传时
    progress(event, file, fileList) {
      if (file.status === 'uploading' || file.status === 'ready') {
        this.$message.warning('图片上传中，请稍候！')
        this.fileButten = false
      } else {
        this.fileButten = true
      }
    },
    // 图片上传之前的校验
    beforeUpload(file) {
      // this.$refs.upload.clearFiles()
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/JPG' ||
        file.type === 'image/JPEG' ||
        file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error('上传图片只能是.jpg,.jpeg,.png,.JPG,.JPEG格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
        return false
      }
      // const isSize = new Promise(function(resolve, reject) {
      //   const _URL = window.URL || window.webkitURL
      //   const img = new Image()
      //   img.onload = function() {
      //     const valid = img.width / img.height === 504 / 282
      //     valid ? resolve() : reject()
      //   }
      //   img.src = _URL.createObjectURL(file)
      // }).then(() => {
      //   return file
      // }, () => {
      //   this.$message.error('上传图片比例只能为504:282, 请重新选择上传!')
      //   return Promise.reject()
      //   // return false // 必须加上return false; 才能阻止
      // })
      //  && isSize
      return isJPG && isLt2M
    },
    // 图片上传成功
    successFile(response, file, fileList) {
      this.fileButten = true
      this.coverImgInfo_ = {
        name: file.name,
        url: response.result
      }
    },
    // 归档项目确定
    submitFilingDialog() {
      filingPro(this.dialog3).then((data) => {
        if (data.code === 10000) {
          var delFlag = ''
          if (this.drawer.info.delFlag === '0') {
            delFlag = '2'
            // this.$message.success('归档项目成功！')
          } else if (this.drawer.info.delFlag === '2') {
            delFlag = '0'
            // this.$message.success('取消归档项目成功！')
          }
          if (this.$route.query.id) {
            var path = ''
            if (this.drawer.info.proTypeId === '2001') {
              path = '/Projects/ModelTask'
            } else {
              path = '/Projects/ProjectsTask'
            }
            this.$router.push({
              path,
              query: {
                id: this.drawer.info.id,
                delFlag
              }
            })
            this.$emit('archiveMethod')
          } else {
            this.$emit('fatherMethod')
          }
          this.dialog3.addDounced = false
          this.drawer.direction = false
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 删除项目确定
    submitDelDialog() {
      delPro(this.dialog).then((data) => {
        if (data.code === 10000) {
          // this.$message.success('删除项目成功！')
          this.dialog.addDounced = false
          this.drawer.direction = false
          if (this.project_id) {
            this.$router.push({
              path: '/Projects'
            })
          }
          this.$emit('proDelChange')
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 选择封面确定
    submitCoverDialog() {
      this.coverImgInfo = this.coverImgInfo_
      this.drawer.info.cover = this.coverImgInfo_.url
      this.dialog4.addDounced = false
      this.$emit('func', this.coverImgInfo)
    },
    // 上传封面弹框取消
    cancelDialog4() {
      this.coverImgInfo = {
        name: this.drawer.info.cover,
        url: this.drawer.info.cover
      }
      this.dialog4.addDounced = false
    },
    // 选择项目封面
    coverImg(item) {
      this.coverImgInfo_ = item
      // this.coverImgInfo_ = {
      //   name: item.name,
      //   url: item.url
      // }
    },
    // 弹框确定2
    submitDialog2() {
      this.copyPros()
    },
    // 计划顺延时间
    putOffBlur() {
      if (this.dialogCopyHeight.putOff < 0 || this.dialogCopyHeight.putOff > 366) {
        return this.$message.warning('计划顺延时间超出范围！')
      }
    },
    // 复制项目接口
    copyPros() {
      if (this.dialogCopyHeight.putOff < 0 || this.dialogCopyHeight.putOff > 366) {
        return this.$message.warning('计划顺延时间超出范围！')
      }
      var copyTaskFlag = '1'
      var fileFlag = '1'
      var labelFlag = '1'
      var followFlag = '1'
      var requenceFlag = '1'
      this.dialogCopyHeight.checkList.map((item) => {
        if (item === '1') {
          copyTaskFlag = '0'
        } else if (item === '2') {
          fileFlag = '0'
        } else if (item === '3') {
          labelFlag = '0'
        } else if (item === '4') {
          followFlag = '0'
        } else if (item === '5') {
          requenceFlag = '0'
        }
      })
      var Ids = []
      this.dialog2.describes.descList.map((item) => {
        Ids.push(item.id)
      })
      var date = {
        id: this.drawer.info.id,
        proname: this.dialog2.proname,
        proNumber: this.dialogCopyHeight.proNumber,
        planStartDate: this.dialog2.planStartDate,
        planEndDate: this.dialog2.planEndDate,
        proRemark: this.dialog2.describes.describe,
        proRemarkFiles: Ids.join(','),
        labelIds: this.tagsObject1.checkboxGroup,
        seniorSetup: {
          copyTaskFlag: copyTaskFlag,
          dateType: this.dialogCopyHeight.dateType,
          putOff: this.dialogCopyHeight.putOff,
          fileFlag: fileFlag,
          labelFlag: labelFlag,
          followFlag: followFlag,
          requenceFlag: requenceFlag
        }
      }
      copyPro(date).then((data) => {
        if (data.code === 10000) {
          this.$message.success('复制项目成功！')
          // this.getList()
          this.dialog2.addDounced = false
          this.dialogCopyHeight.addDounced = false
          // this.drawer.direction = false
          this.$emit('fatherMethod', 'copy')
        } else {
          this.$message.warning(data.info)
        }
      }).catch(() => {
        // this.$message.warning('网络错误，请稍候！')
      })
    },
    // 复制任务高级选项
    advancedSele() {
      var date = {
        typeId: ''
      }
      getProNumber(date).then((data) => {
        if (data.code === 10000) {
          this.dialogCopyHeight.proNumber = data.result
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
      this.dialog2.addDounced = false
      this.dialogCopyHeight.addDounced = true
      // console.log(66)
    },
    // 复制任务上一步
    lastStep() {
      this.dialog2.addDounced = true
      this.dialogCopyHeight.addDounced = false
    },
    // 复制任务按钮
    copyTask() {
      this.copyPros()
    },
    // 关闭前的回调(弹框)
    beforeClose(val) {
      this.dialog3.addDounced = val.addDounced
      this.dialog.addDounced = val.addDounced
      this.dialogCopyHeight.addDounced = val.addDounced
      this.dialog2.addDounced = val.addDounced
      this.dialog4.addDounced = val.addDounced
    },
    // 弹框确定
    submitDialog() {
      this.dialog.addDounced = false
    },
    // 弹框取消
    cancelDialog() {
      this.dialog.addDounced = false
      this.dialogCopyHeight.addDounced = false
      this.dialog3.addDounced = false
      this.dialog2.addDounced = false
      this.dialog4.addDounced = false
    },
    // 关闭前的回调(侧边栏)
    handleClose(val) {
      this.drawer.direction = false
      this.$emit('drawerVisible', this.drawer)
    },
    // 计划结束时间(复制项目)
    focusStartChange() {
      var that = this
      this.pickerOptions = {
        disabledDate(time) {
          return time.getTime() > (Date.parse(that.dialog2.planEndDate) - 86399000)
        }
      }
    },
    // 计划结束时间(复制项目)
    focusEndChange() {
      var that = this
      this.pickerOptions1 = {
        disabledDate(time) {
          return time.getTime() < Date.parse(that.dialog2.planStartDate)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/index.scss';
.cover_box {
  width: 832px;
  background: $color_white;
  border-radius: 8px;
  border: 1px solid #E2E2E2;
  margin: auto;
  margin-bottom: 5px;
  display: flex;
}
.cover_left {
  width: 410px;
  padding: 20px;
  height: 520px;
  border-right: 1px solid #E2E2E2;
}
.cover_title {
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_3;
  line-height: 20px;
}
.cover_list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 8px;
  margin-left: -3px;
}
.cover_img {
  width: 162px;
  height: 90px;
  border-radius: 10px;
  margin-left: 21px;
  margin-top: 23px;
  vertical-align: middle;
  cursor: pointer;
}
.preview_img {
  width: 162px;
  height: 90px;
  border-radius: 10px;
  border: 1px solid #E2E2E2;
  margin-bottom: 19px;
  vertical-align: middle;
  overflow: hidden;
}
.cover_right {
  width: 355px;
  padding: 20px 30px;
}
.cover_select {
  display: flex;
  align-items: flex-start;
  margin-top: 32px;
  color: $color_3;
}
.cover_text {
  color: $color_9;
  margin-top: 6px;
}
.copy_conyent {
  margin: 5px 42px 10px 47px;
}
.copy_label {
  font-size: $font_16;
  font-family: $font_family;
  font-weight: 500;
  color: $color_3;
  margin-bottom: 10px;
}
.copy_value {
  width: calc(100% - 32px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  margin-left: 32px;
}
.copy_tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .copy_tags_box {
    position: relative;
    cursor: pointer;
    .del_icon {
      font-size: 13px;
      color: $color_9;
      position: absolute;
      top: -6px;
      right: 8px;
      display: none;
    }
    .del_icon:hover {
      color: $color_main;
    }
  }
  .add_icon {
    font-size: $font_18;
    color: $color_9;
    // margin: 0 24px;
    cursor: pointer;
  }
  .add_icon:hover {
    color: $color_main;
  }
}
.copy_tags_box:hover .del_icon {
  display: block;
}
.archive_content {
  margin: 5px 12px 0 12px;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_3;
  line-height: 24px;
  text-indent: 28px;
}
.desc_boxs {
  display: flex;
  .desc{
    display: flex;
    margin-top: 10px;
    margin-left: 13px;
    p{
      width: 28px;
    height: 20px;
    font-size: 14px;
    margin-right: 14px;
    }
    .iconfont{
      margin-right: 7px;
    }
  }
  ::v-deep .el-radio{
    display: block;
  }
  .task-name,
  .seleTime,
  .seleCopy{
      width: 64px;
      height: 22px;
      font-size: 16px;
      font-family: $font_family1;
      font-weight: 500;
      color: #303030;
      line-height: 22px;
      margin-left: 35px;
  }
  .tt{
    .el-input{
      width: 383px ;
      height: 36px;
      margin: 8px 0 24px 56px
    }
  }
  .aa{
    ::v-deep .el-input{
      width: 91px ;
      height: 24px !important;
    }
    ::v-deep .el-input__inner{
      height: 24px !important;
      line-height: 24px;
    }
  }
  .sele-copy{
    margin-left: 56px;
    margin-top: 16px;
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: $color_main;
      border-color: $color_main;
    }
    ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
      color: $color_main;
    }
  }
  .el-radio-group{
    margin-left: 56px;
    .el-radio{
      font-size: 14px;
      color: #303030;
      margin: 9px 0;
      padding: 9px 0;
    }
  }
}
.subbox {
  margin:  0 14px !important;
    font-size: 14px;
    font-family: $font_family1;
    font-weight: 400;
    color: #303030;
    line-height: 24px;
    text-indent: 28px;
}
</style>
